$shm_radio $mol_check
	aria_role \radio
	Icon $mol_view
		sub <= circle_inner /
			<= Circle_inner $mol_view
